import React, { useState } from 'react';
import styled from 'styled-components';

import { useOutsideClick } from '@/shared/application/utils/outsideClick';

const Kebab = styled.div`
  display: inline-block;
  box-sizing: border-box;
  position: relative;
`;

const Content = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  width: fit-content;
  cursor: pointer;
`;

const Dropdown = styled.ul<{ align?: string }>`
  background-color: white;
  width: 4.5rem;
  padding: 0;
  position: absolute;
  transition: all 0.25s ease-out;
  display: none;
  transform-origin: 100% 0;
  top: 20px;
  left: 0;
  ${(props) => props.align || 'left'}: 0;
  margin: 0;
  z-index: 1;

  &.active {
    display: flex;
    flex-direction: column;
  }

  &,
  li:last-child {
    border-radius: 0 0 10px 10px;
  }
`;

const DropdownItem = styled.li`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  cursor: pointer;

  &:hover {
    background: #efefef;
  }

  ${Dropdown}:hover & {
    transform: scale(1);
  }

  span {
    text-align: center;
    color: black;
  }

  border: 1px solid grey;
`;

const Text = styled.span`
  color: #6b6b6b;
  width: 100%;
  display: inline-block;
  white-space: pre;
  box-sizing: border-box;
`;

export type Item = {
  label: string;
  icon: string;
  onClick: () => void;
};

type Props = {
  items: Item[];
  buttonComponent: any;
};

const LinkDownloadIo: React.FC<Props> = ({ items, buttonComponent }) => {
  const [open, setOpen] = useState<boolean>(false);
  const ref = React.useRef<HTMLDivElement>(null);

  useOutsideClick(ref, () => {
    setOpen(false);
  });

  return (
    <Kebab
      ref={ref}
      onClick={(e) => {
        e.stopPropagation();
        setOpen(!open);
      }}
      className={open && 'dropdown-kebab-active'}
    >
      <Content>
        {buttonComponent}
        <Dropdown align="right" className={open && 'active'}>
          {items?.map((item, key) => {
            return (
              <DropdownItem key={key} onClick={item.onClick}>
                <Text>{item.label}</Text>
              </DropdownItem>
            );
          })}
        </Dropdown>
      </Content>
    </Kebab>
  );
};

export default LinkDownloadIo;
